import React, {Component} from "react"
import PropTypes from "prop-types"
import {connect} from "react-redux"
import {Col, Glyphicon, Nav, NavItem, Row, Tab, Tabs} from 'react-bootstrap'
import {LinkContainer} from 'react-router-bootstrap'
import {loadRace,
	dispatchRaceResultsRequest, dispatchRaceResults,
	dispatchRaceResultIntermediatesRequest, dispatchRaceResultIntermediates} from "../actions/online"
import {defaultState} from "../reducers/paginate"
import {defaultState as entityDefaultState} from '../reducers/entity'
import Results from "../components/result/Results"
import {changeHeaderContent} from "../actions";
import {breadcrumbs, Grid} from "../components/utils";
import * as Date from "../components/utils/date";
import {hashHistory} from "react-router";
import ResultIntermediates from "../components/result/ResultIntermediates";
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import {WS_ROOT} from "../middleware/backend";

const resultsInterval = {
	interval: null,
	key: null
};

const clearResultInterval = () => {
	if (resultsInterval.interval) {
		clearInterval(resultsInterval.interval);
	}
	resultsInterval.interval = null;
	resultsInterval.key = null;
};

const getResultHash = (result) => {
	return 'tt-' + result.totalTime;
};

const getResultInterHash = (inter) => {
	return 'tt-' + inter.tt;
};

class ResultsPage extends Component {

	stompClient = null;
	stompSubscription = null;
	stompUserQueue = null;
	stompSubTimeout = null;

	constructor(props) {
		super(props);

		this.handleTabSelect = this.handleTabSelect.bind(this);
		this.stompSubscribe = this.stompSubscribe.bind(this);
		this.stompReceive = this.stompReceive.bind(this);

		this.state = {
			topResults: {},
			lastResults: {},
			lastResultsInter: {},
			seenResults: {},
			seenResultsInter: {}
		}
	}

	stompConnect(isRetry = false) {
		const that = this;
		this.stompClient = Stomp.over(new SockJS(WS_ROOT));
		this.stompClient.debug = false;
		this.stompClient.connect({}, () => {
			this.stompUserQueue = this.stompClient.subscribe('/user/results', (data) => {
				that.stompReceive(data)
			});
			if (isRetry) {
				that.loadDataIfAvailable(that.props);
			}
		}, () => {
			setTimeout(() => {
				this.stompUserQueue = null;
				that.stompConnect(true);
			}, 5000);
		});
	}

	loadDataIfAvailable(props) {
		const {params, loadRace} = props;

		if (params.seasonId && params.eventId && params.raceId) {
			loadRace({
				seasonId: params.seasonId,
				eventId: params.eventId,
				raceId: params.raceId
			});
			if (params.compGroupId) {
				this.stompSubscribe(params);
			}
		}
	}

	stompSubscribe(params) {
		clearTimeout(this.stompSubTimeout);

		if (!this.stompUserQueue) {
			if (!this.stompSubTimeout) {
				const that = this;
				this.stompSubTimeout = setTimeout(() => that.stompSubscribe(params), 1000);
			}
			return;
		}

		if (this.stompSubscription) {
			this.stompSubscription.unsubscribe();
		}
		const that = this;
		if (params.tab === 'mezicasy') {
			this.props.dispatchRaceResultIntermediatesRequest(params);
		} else {
			this.props.dispatchRaceResultsRequest(params);
		}
		this.stompSubscription = this.stompClient.subscribe(
			'/results/' + params.seasonId
			+ '/' + params.eventId
			+ '/' + params.raceId
			+ '/' + params.compGroupId
			+ (params.tab === 'mezicasy' ? '/inter' : ''),
			(data) => {
				that.stompReceive(data)
			});
	}

	stompReceive(payload) {
		const d = JSON.parse(payload.body);
		if (d && d.isInter) {
			return this.props.dispatchRaceResultIntermediates(d);
		} else {
			return this.props.dispatchRaceResults(d);
		}
	}

	componentWillMount() {
		this.stompConnect();
		this.loadDataIfAvailable(this.props);
	}

	componentWillReceiveProps(nextProps) {
		const {params} = this.props;
		const {topResults, lastResults, lastResultsInter, seenResults, seenResultsInter} = this.state;

		if (params.seasonId !== nextProps.params.seasonId
			|| params.eventId !== nextProps.params.eventId
			|| params.raceId !== nextProps.params.raceId
			|| params.compGroupId !== nextProps.params.compGroupId
			|| ((params.tab || 'vysledky') !== (nextProps.params.tab || 'vysledky'))
		) {
			let updated = false;
			if (params.compGroupId !== nextProps.params.compGroupId) {
				// clear current so it does not re-appear
				if (params.compGroupId && topResults[params.compGroupId] && topResults[params.compGroupId].highlight) {
					topResults[params.compGroupId].highlight = false;
					updated = true;
				}
				// clear destination as we are going there
				if (nextProps.params.compGroupId && topResults[nextProps.params.compGroupId] && topResults[nextProps.params.compGroupId].highlight) {
					topResults[nextProps.params.compGroupId].highlight = false;
					updated = true;
				}
			} else if ((params.tab || 'vysledky') !== (nextProps.params.tab || 'vysledky')) {
				// clear destination as we are going there
				if (nextProps.params.compGroupId && topResults[nextProps.params.compGroupId] && topResults[nextProps.params.compGroupId].highlight) {
					topResults[nextProps.params.compGroupId].highlight = false;
					updated = true;
				}
			}

			if (updated) {
				this.setState({topResults}, () => {
					this.loadDataIfAvailable(nextProps);
				});
			} else {
				this.loadDataIfAvailable(nextProps);
			}
			return
		}

		let currentTopUsers = false;
		let currentTopUsersTs = null;
		if (params.tab === 'mezicasy'
			&& nextProps.raceResultInter && nextProps.raceResultInter.item
			&& nextProps.raceResultInter.item.topUsers && nextProps.raceResultInter.item.topUsers.length) {
			currentTopUsers = nextProps.raceResultInter.item.topUsers;
			currentTopUsersTs = nextProps.raceResultInter.item.ts;

		} else if (nextProps.raceResult && nextProps.raceResult.item
			&& nextProps.raceResult.item.topUsers && nextProps.raceResult.item.topUsers.length) {
			currentTopUsers = nextProps.raceResult.item.topUsers;
			currentTopUsersTs = nextProps.raceResult.item.ts;
		}

		if (currentTopUsers) {
			const groups = {};
			for (let i = 0; i < currentTopUsers.length; i++) {
				const tu = currentTopUsers[i];
				if (!groups[tu.compGroupId]) {
					groups[tu.compGroupId] = {};
				}
				groups[tu.compGroupId][tu.rank] = tu;
			}
			// const now = Date.currentTS();
			for (let compGroupId in groups) {
				if (!groups.hasOwnProperty(compGroupId)) {
					continue;
				}
				const newHash = JSON.stringify(groups[compGroupId]);
				if (!topResults[compGroupId]) {
					topResults[compGroupId] = {
						hash: newHash,
						highlight: false,
						ts: currentTopUsersTs
					};
				} else if (newHash !== topResults[compGroupId].hash && !(currentTopUsersTs < topResults[compGroupId].ts)) {
					topResults[compGroupId] = {
						hash: newHash,
						highlight: true,
						ts: currentTopUsersTs
					};
				}
			}
		}
		const now = Date.currentTS();

		let currentResults = false;
		if (nextProps.raceResult && nextProps.raceResult.item
			&& nextProps.raceResult.item.resultUsers) {
			currentResults = nextProps.raceResult.item.resultUsers;
		}

		if (currentResults) {
			for (let i = 0; i < currentResults.length; i++) {
				const ru = currentResults[i];
				const key = ru.compGroupId + '-' + ru.racerId;
				const newHash = getResultHash(ru);
				if (!lastResults[key] || newHash !== lastResults[key].hash || (ru.rank && !lastResults[key].rank)) {
					lastResults[key] = {
						hash: newHash,
						update: lastResults[key] || seenResults[nextProps.params.compGroupId] ? now : 0,
						rank: ru.rank
					};
				}
			}
			seenResults[nextProps.params.compGroupId] = true;
		}

		let currentResultsInter = false;
		if (nextProps.raceResultInter && nextProps.raceResultInter.item
			&& nextProps.raceResultInter.item.resultUsers) {
			currentResultsInter = nextProps.raceResultInter.item.resultUsers;
		}

		if (currentResultsInter) {
			for (let i = 0; i < currentResultsInter.length; i++) {
				const ru = currentResultsInter[i];
				if (!ru.intermediates || !ru.intermediates.length) {
					continue;
				}
				for (let j = 0; j < ru.intermediates.length; j++) {
					const inter = ru.intermediates[j];
					const key = ru.compGroupId + '-' + ru.racerId;
					const newHash = getResultInterHash(inter);
					if (!lastResultsInter[inter.c]) {
						lastResultsInter[inter.c] = {};
					}
					if (!lastResultsInter[inter.c][key] || newHash !== lastResultsInter[inter.c][key].hash || (inter.r && !lastResultsInter[inter.c][key].rank)) {
						lastResultsInter[inter.c][key] = {
							hash: newHash,
							update: lastResultsInter[inter.c][key] || seenResultsInter[nextProps.params.compGroupId] ? now : 0,
							rank: inter.r
						};
					}
				}
			}
			seenResultsInter[nextProps.params.compGroupId] = true;
		}

		this.setState({topResults, lastResults, lastResultsInter, seenResults, seenResultsInter});
	}

	componentWillUnmount() {
		if (this.stompClient) {
			clearTimeout(this.stompSubTimeout);
			this.stompClient.disconnect();
		}
		clearResultInterval();
	}

	handleTabSelect(tab) {
		const {params} = this.props;
		if ((tab || 'vysledky') === (params.tab || 'vysledky')) {
			return
		}
		hashHistory.push('/' + params.seasonId + '/' + params.eventId + '/' + params.raceId + '/' + params.compGroupId
			+ (tab === 'vysledky' ? '' : ('/' + tab)))
	}

	render() {
		const {raceInfo, raceResult, raceResultInter, seasonsPage, params} = this.props;
		const {topResults, lastResults, lastResultsInter} = this.state;
		const tab = params.tab || 'vysledky';

		const info = (raceInfo ? raceInfo.item : null);
		const race = (info && info.race && info.race.raceId ? info.race : null);
		let season = null;
		if (race && seasonsPage && seasonsPage.items && seasonsPage.items.length) {
			for (let i = 0; i < seasonsPage.items.length; i++) {
				if (seasonsPage.items[i].seasonId === race.seasonId) {
					season = seasonsPage.items[i];
					break;
				}
			}
		}

		const links = [];
		// const now = Date.currentTS();
		if (info && info.compGroups && info.compGroups.length) {
			for (let i = 0; i < info.compGroups.length; i++) {
				const group = info.compGroups[i];
				const highlight = topResults[group.compGroupId] && topResults[group.compGroupId].highlight && (1 * params.compGroupId) !== group.compGroupId;
				links.push(<LinkContainer key={i}
					to={'/' + race.seasonId + '/' + race.eventId + '/' + race.raceId + '/' + group.compGroupId + (params.tab ? '/' + params.tab : '')}>
					<NavItem className={highlight ? "highlightit" : ""}>{group.title}</NavItem>
				</LinkContainer>);
			}
		}

		const bc = [];
		if (race) {
			bc.push({url: '/' + race.seasonId + '/', title: season ? season.title : race.seasonId});
			bc.push({url: '/' + race.seasonId + '/' + race.eventId + '/' + race.raceId, title: race.title + ' - ' + race.raceType + ', ' + Date.formatDate(race.raceDate) + ', ' + race.location});
		}

		// XXX
		if (window.location.hash && window.location.hash.lastIndexOf('#') !== window.location.hash.indexOf('#')) {
			const anchor = window.location.hash.substring(window.location.hash.lastIndexOf('#') + 1);
			if (anchor) {
				const scrollInterval = setInterval(() => {
					const el = document.getElementById(anchor);
					if (el) {
						el.scrollIntoView();
						clearInterval(scrollInterval);
					}
				}, 100);
			}
		}

		let icon;
		if (this.stompUserQueue == null) {
			icon = <Glyphicon glyph={'hourglass'} title={'Navazuje se spojení se serverem ...'} />
		} else if (tab === 'vysledky' && raceResult.isFetchingItem && raceResult.item && raceResult.item.resultUsers) {
			icon = Grid.renderIsFetchingData("");
		} else if (tab === 'mezicasy' && raceResultInter.isFetchingItem && raceResultInter.item && raceResultInter.item.resultUsers) {
			icon = Grid.renderIsFetchingData("");
		}

		const tabUpdated = params.compGroupId && topResults[params.compGroupId] && topResults[params.compGroupId].highlight;
		return (<div>
				<Row>
					<Col xs={12}>
						{breadcrumbs(bc)}
					</Col>
				</Row>
				<Row className={"results-content"}>
					<Col sm={2} className={"main-menu"}>
						<Nav bsStyle="pills" stacked>
							{links}
						</Nav>
					</Col>
					{params.compGroupId ? <Col sm={10}>
							<Tabs activeKey={tab} onSelect={this.handleTabSelect} animation={false} id={'result-tabs'}>
								<Tab eventKey="vysledky" title="Průběžné výsledky" tabClassName={tabUpdated && tab === 'mezicasy' ? 'highlightit' : null}>
									{tab === 'vysledky' && <Results compGroupId={params.compGroupId}
										raceInfo={raceInfo}
										raceResult={raceResult}
										lastResults={lastResults}
										seasons={seasonsPage}/>}
								</Tab>
								{race && race.isIntermediates ? <Tab eventKey="mezicasy" title="Průběžné mezičasy">
									{tab === 'mezicasy' && <ResultIntermediates compGroupId={params.compGroupId}
										raceInfo={raceInfo}
										raceResult={raceResultInter}
										lastResults={lastResultsInter}
										seasons={seasonsPage}/>}
								</Tab> : null}
							</Tabs>
							<div id={"result-loader"}>
								{icon}
							</div>
						</Col>
						: <Col sm={4} className={"result-warning"}>
							<p className={"alert alert-warning"}>Zvolte prosím kategorii v nabídce.</p>
						</Col>}
				</Row>
			</div>
		)
	}
}

ResultsPage.propTypes = {
	raceInfo: PropTypes.object,
	seasonsPage: PropTypes.object,
	raceResult: PropTypes.object,
	raceResultInter: PropTypes.object,
	enums: PropTypes.object,
	loadRace: PropTypes.func.isRequired,
	dispatchRaceResultsRequest: PropTypes.func.isRequired,
	dispatchRaceResults: PropTypes.func.isRequired,
	dispatchRaceResultIntermediatesRequest: PropTypes.func.isRequired,
	dispatchRaceResultIntermediates: PropTypes.func.isRequired,
};


const
	mapStateToProps = (state, ownProps) => {
		const {
			pagination: {seasons},
			entities: {races, raceResults, raceResultIntermediates},
			enums,
		} = state;

		const seasonsPage = seasons[0] || defaultState;

		let key = null;
		if (ownProps.params.seasonId && ownProps.params.eventId && ownProps.params.raceId) {
			key = ownProps.params.seasonId + '-' + ownProps.params.eventId + '-' + ownProps.params.raceId;
		}

		const raceInfo = key
			? (races[key] || entityDefaultState)
			: Object.assign(defaultState, {item: {}});

		let key2 = null;
		if (key && ownProps.params.compGroupId) {
			key2 = key + '-' + ownProps.params.compGroupId;
		}

		const raceResult = key2
			? (raceResults[key2] || entityDefaultState)
			: Object.assign(defaultState, {item: {}});

		const raceResultInter = key2
			? (raceResultIntermediates[key2] || entityDefaultState)
			: Object.assign(defaultState, {item: {}});

		return {
			enums,
			seasonsPage,
			raceInfo,
			raceResult,
			raceResultInter
		}
	};

export default connect(mapStateToProps, {
	loadRace,
	dispatchRaceResultsRequest,
	dispatchRaceResults,
	dispatchRaceResultIntermediatesRequest,
	dispatchRaceResultIntermediates,
	changeHeaderContent
})(ResultsPage)



// WEBPACK FOOTER //
// ./P:/Work/htdocs/biatlon/online/src/containers/ResultsPage.js